/**
 * Represents an JavaScript exception that occurs during a GraphQL query.
 */
var GraphQLError = /** @class */ (function () {
    /**
     * Creates a new `GraphQLError` instance with the specified query response.
     *
     * @param data The response for the query that caused the error.
     */
    function GraphQLError(data) {
        this.response = data;
        // Set the error message based on the response
        this.message = data.errors && data.errors.length ? data.errors[0].message : "Unknown error";
        if (!data.networkError) {
            this.graphQLErrors = data.errors;
        }
    }
    return GraphQLError;
}());
export default GraphQLError;
